// src/data/dailyPlanners.js
// Ab ye backend se fetch karta hai (Daily Planner category), static array nahi hai.

const API_BASE = "https://aishcraft.com/backend/api";

export const PRODUCTS_PER_PAGE = 12;

let _cache = null;   // fetched products memory me cache honge
let _cachePromise = null;

async function fetchDailyPlanners() {
  if (_cache) return _cache;
  if (_cachePromise) return _cachePromise;

  _cachePromise = fetch(`${API_BASE}/public/products.php?category=daily-planner`)
    .then(res => res.json())
    .then(json => {
      if (json.success === false) throw new Error(json.message || "Failed to load products");
      _cache = json.data || [];
      return _cache;
    })
    .catch(err => {
      _cachePromise = null;
      throw err;
    });

  return _cachePromise;
}

// Preloads and returns the array (used by CollectionPage/DailyPlanner.jsx with loading state)
export async function getDailyPlanners() {
  return fetchDailyPlanners();
}

export async function getProductBySlug(slug) {
  const products = await fetchDailyPlanners();
  return products.find(p => p.id === slug);
}

export async function getRelatedProducts(slug, count = 4) {
  const products = await fetchDailyPlanners();
  const current = products.find(p => p.id === slug);
  if (!current) return [];
  const pool = products.filter(p => p.id !== slug);
  const sameTag = pool.filter(p => p.tag === current.tag);
  const rest = pool.filter(p => p.tag !== current.tag);
  return [...sameTag, ...rest].slice(0, count);
}